import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "space-y-9" }
const _hoisted_3 = { class: "flex flex-wrap items-end gap-4" }

import Card from 'primevue/card';

import CalculationSegmentsTable from '../components/CalculationSegmentsTable.vue';
import SegmentsSummary from '../components/SegmentsSummary.vue';
import CalculationWidget from '../components/CalculationWidget.vue';
import DownloadAgreement from '../components/DownloadAgreement.vue';
import DownloadOffer from '../components/DownloadOffer.vue';
import DownloadFinancingOffer from '../components/DownloadFinancingOffer.vue';
import DownloadCalculationSummaryCsv from '../components/DownloadCalculationSummaryCsv.vue';
import CalculationOutdatedStatus from '../components/CalculationOutdatedStatus.vue';
import CalculationNameInput from '../components/CalculationNameInput.vue';
import CalculationItemsVisibilityButton from '../components/CalculationItemsVisibilityButton.vue';

import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useCurrentEstimatedSegments } from '../composables/useCurrentEstimatedSegments';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationSummaryView',
  setup(__props) {

const { currentCalculation } = useCurrentCalculation();
const { hasFinancingSegments } = useCurrentEstimatedSegments();

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_unref(Card), { class: "h-max flex-1 basis-[354px] border border-gray-200 !shadow-none" }, {
    content: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(currentCalculation)?.outdated)
            ? (_openBlock(), _createBlock(CalculationOutdatedStatus, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("header", _hoisted_3, [
            (_unref(currentCalculation))
              ? (_openBlock(), _createBlock(CalculationNameInput, {
                  key: 0,
                  class: "flex-1",
                  calculation: _unref(currentCalculation)
                }, null, 8, ["calculation"]))
              : _createCommentVNode("", true),
            _createVNode(CalculationItemsVisibilityButton),
            _createVNode(DownloadCalculationSummaryCsv),
            _createVNode(DownloadAgreement),
            _createVNode(DownloadOffer),
            (_unref(hasFinancingSegments))
              ? (_openBlock(), _createBlock(DownloadFinancingOffer, { key: 1 }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(CalculationWidget),
          _createVNode(CalculationSegmentsTable),
          _createVNode(SegmentsSummary)
        ])), [
          [_directive_auto_animate]
        ])
      ])), [
        [_directive_auto_animate]
      ])
    ]),
    _: 1
  }))
}
}

})